var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const DEFAULT_HEADERS = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};
const responseCache = new Map();
export function httpRequest(requestUrl, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const cacheKey = JSON.stringify({ requestUrl, options });
        if (responseCache.has(cacheKey)) {
            return responseCache.get(cacheKey);
        }
        const promise = (() => __awaiter(this, void 0, void 0, function* () {
            const { headers = {} } = options !== null && options !== void 0 ? options : {};
            const response = yield fetch(requestUrl, Object.assign(Object.assign({}, options), { headers: Object.assign(Object.assign({}, DEFAULT_HEADERS), headers) }));
            response.parsedBody = yield response.json().catch((error) => {
                throw error;
            });
            if (!response.ok) {
                throw new HttpRequestError(`Error fetching ${requestUrl}: ${response.statusText}`, response.status, response.statusText);
            }
            responseCache.set(cacheKey, response);
            return response;
        }))();
        responseCache.set(cacheKey, promise);
        try {
            return yield promise;
        }
        catch (e) {
            responseCache.delete(cacheKey);
            throw e;
        }
    });
}
export class HttpRequestError extends Error {
    constructor(msg, _statusCode, _statusText) {
        super(msg);
        this._statusCode = _statusCode;
        this._statusText = _statusText;
        Object.setPrototypeOf(this, HttpRequestError.prototype);
    }
    get statusCode() {
        return this._statusCode;
    }
    get statusText() {
        return this._statusText;
    }
}
